import { useState, useEffect } from 'react';

const Menubar = ({ home, solutions, features, connectivity, successstories, bookDemo }) => {

    const [open, setOpen] = useState(false)
    const [a, setA] = useState('')
    const [b, setB] = useState('')
    const [c, setC] = useState('')

    const handleDropdown = () => {
        setOpen(!open)
    }

    useEffect(() => {
        if(open){
            setA('a')
            setB('b')
            setC('c')
        }
        else{
            setA('')
            setB('')
            setC('')
        }
      }, [open])


  return (
    <div className='headerWrapper ad-landing'>
        <header className="header_area header_stick nav-black brad48" id= "headerarea">
            <nav className='navbar navbar-expand-lg menu_center mainsite1'>
                <div className='container custom_container'>
                    <div className='site-mast-left'>
                        <a href="#" className="navbar-brand sticky_logo">
                            <img width="210" height="45" className="site-logo" src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png" alt= "" />
                        </a>
                    </div>
                    <div className='justify-content-center vfit-main'>
                        <div id='menu-main-menu-global' className='d-none d-lg-flex navbar-nav menu  ml-auto'>
                            <div className='nav-home menu-item nav-item HeaderN justify-content-center align-items-center'>
                                <a href={home} className='site-nav-item'>Home</a>
                                <a href={solutions} className='site-nav-item'>Solutions</a>
                                <a href={features} className='site-nav-item'>Features</a>
                                <a href={connectivity} className='site-nav-item'>Connectivity</a>
                                <a href={successstories} className='site-nav-item'>Success Stories</a>
                                <a href={bookDemo} className='menu_cus btn_get btn-meta btn_hover menu-top'>Book a Demo</a>
                            </div>
                        </div>
                    </div>
                        <div className='d-flex d-lg-none align-items-center justify-content-end'  onClick={handleDropdown}>
                            <a href='' className='text-white d-flex flex-column justify-content-center align-items-center' style={{ backgroundColor: '#FBECEC', borderRadius: '50%', padding: '8px 10px', height: '45px', width: '45px' }}>
                                <div className="icon-1" id={a}></div>
                                <div className="icon-2" id={b}></div>
                                <div className="icon-3" id={c}></div>
                            </a>
                        </div>
                </div>

            </nav>
        </header>
        <div className={open ? 'dropdownActive gcwmobile-menu bg-white pt-2 d-flex flex-column overflow-x-hidden pb-5' : 'dropdown overflow-hidden h-0'}>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={home} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Home</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={solutions} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Solutions</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={features} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Features</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={connectivity} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Connectivity</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={successstories} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Success Stories</a></div>
                <div className='text-dark'  onClick={handleDropdown} style= {{ borderBottom: '1px solid #fadcdc'}}><a href={bookDemo} className= "pull-left col-12 px-3 py-3 text-dark w-100" style= {{ float: 'left' }}>Book a Demo</a></div>
            </div>
    </div>
  )
}

export default Menubar
